<template>
  <div>
    <span class="pager--start">{{start}}</span>
    <div class="subscriptpager">
      <span class="pager--stripe">/</span>
      <span class="pager--end">{{end}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['start','end'],
}
</script>

<style>

  .subscriptpager{
    display: inline-flex;
    position: relative;
    align-items: baseline;
    left: 5px;
    top:-5px;
  }

  .pager--start{
    display: inline-block;
    font-family: "Playfair Display";
    font-size: 3.2rem;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: var(--titleslidecolor);
  }

  .pager--stripe{
    display: inline-block;
    font-family: "Playfair Display";
    font-size: 1.6rem;
    letter-spacing: 0.8px;
    color: var(--lightorange);
    
  }

  .pager--end{
    display: inline-block;
    font-family: "Playfair Display";
    font-size: 1.6rem;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: var(--titleslidecolor);
   
    
  }

  @media only screen and (min-width: 900px) {


  }
  @media only screen and (min-width: 1200px) {
    .pager--start{
      font-size: 4rem;
    }
    .pager--stripe, .pager--end {
      font-size: 2rem;
    }
  }

</style>


